import React, { ElementType, useState } from 'react'
import * as S from './index.style'
import TextField from '@material-ui/core/TextField'
import { Checkbox, FormControlLabel, InputBaseComponentProps, MenuItem } from '@material-ui/core'
import { MascaraDecimal } from 'components/Mascara/Decimal'
import { DadosComercial, ValidacaoDadosComercial } from 'models/Viabilidade/Comercial'
import { CamposParcelasComercialEnum } from 'models/Viabilidade/Enum/CamposParcelasComercialEnum'
import Grid from 'components/Grid'

export type CardComercialProps = {
  dadosComercial: DadosComercial
  dadosComercialHandler: (novoValor: DadosComercial) => void
}

const CardComercial: React.FC<CardComercialProps> = ({ dadosComercial, dadosComercialHandler }) => {
  const [valores, setValores] = useState(dadosComercial)
  const [mensagensErro, setMensagensErro] = useState(new ValidacaoDadosComercial())

  const replaceState = (event: React.ChangeEvent<HTMLInputElement>): Record<string, unknown> => {
    const state = { ...valores } as Record<string, unknown>
    state[event.target.name] = event.target.value
    return state
  }

  const camposHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = replaceState(event) as DadosComercial
    setValores(state)
    dadosComercialHandler(state)
  }

  const checkboxHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = { ...valores, [event.target.name]: event.target.checked }

    setValores(state)
    dadosComercialHandler(state)
  }

  const validarDescontoBomPagador = () => {
    const erroDescontoBomPagador = mensagensErro.validarDescontoBomPagador(valores.descontoBomPagador)
    const validador = new ValidacaoDadosComercial(erroDescontoBomPagador, mensagensErro.parcelamento)
    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarParcelamento = () => {
    const erroParcelamento = mensagensErro.validarParcelamento(valores.parcelamento)
    const validador = new ValidacaoDadosComercial(mensagensErro.descontoBomPagador, erroParcelamento)
    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarCard = (validador: ValidacaoDadosComercial) => {
    const state = { ...valores } as DadosComercial

    state.valido = validador.validarTodosCampos(state)
    setValores(state)
    dadosComercialHandler(state)
  }

  return (
    <S.Wrapper>
      <Grid orientacao="column" gridTemplateColumns="repeat(3, 220px)" gridTemplateRow="1fr" gridGap="48px" margin="0">
        <div>
          <FormControlLabel
            value="start"
            control={<Checkbox color="secondary" name="descontoItbiRegistro" onChange={checkboxHandler} />}
            label="Desconto ITBI/Registro (%)"
            labelPlacement="end"
            checked={valores.descontoItbiRegistro}
            data-cy="campoDescontoItbiRegistro"
          />
        </div>
        <div>
          <S.Label>Desconto Bom Pagador (R$)</S.Label>
          <TextField
            placeholder="00.000,00"
            name="descontoBomPagador"
            data-cy="campoDescontoBomPagador"
            value={valores.descontoBomPagador}
            onChange={camposHandler}
            onBlur={validarDescontoBomPagador}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.descontoBomPagador != ''}
            helperText={mensagensErro.descontoBomPagador}
          />
        </div>
        <div>
          <S.Label>Parcelamento (meses)</S.Label>
          <TextField
            name="parcelamento"
            data-cy="campoParcelamento"
            value={valores.parcelamento}
            fullWidth
            variant="outlined"
            size="small"
            onChange={camposHandler}
            onBlur={validarParcelamento}
            error={mensagensErro.parcelamento != ''}
            helperText={mensagensErro.parcelamento}
            select
          >
            {Object.keys(CamposParcelasComercialEnum)
              .filter((e) => !isNaN(Number(e)))
              .map((parcela) => (
                <MenuItem key={parcela} value={parcela} data-cy={`tipoParcelamento${parcela}x`}>
                  {parcela}
                </MenuItem>
              ))}
          </TextField>
        </div>
      </Grid>
    </S.Wrapper>
  )
}

export default CardComercial
